// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ============================================
   VINA AI UNIFIED DESIGN SYSTEM
   Bridging marketing site + web application
   ============================================ */

:root {
  /* Brand Colors - Updated to match menu selection (Indigo/Blue) */
  --brand-purple: #818CF8;
  --brand-purple-deep: #4F46E5;
  --brand-blue: #60A5FA;
  --brand-blue-deep: #2563EB;
  --brand-green: #34D399;
  --brand-pink: #F472B6;
  --brand-amber: #FBBF24;

  /* Semantic Colors */
  --color-success: #34D399;
  --color-success-muted: rgba(34, 197, 94, 0.15);
  --color-error: #F87171;
  --color-error-muted: rgba(239, 68, 68, 0.15);
  --color-warning: #FBBF24;
  --color-warning-muted: rgba(245, 158, 11, 0.15);
  --color-info: #60A5FA;
  --color-info-muted: rgba(59, 130, 246, 0.15);

  /* Gradients */
  --gradient-brand: linear-gradient(135deg, #818CF8 0%, #60A5FA 100%);
  --gradient-brand-deep: linear-gradient(135deg, #4F46E5 0%, #2563EB 100%);
  --gradient-hero: linear-gradient(135deg, #4F46E5 0%, #2563EB 100%);

  /* App-shell gradients. Theme-independent, so they read the same on the light
     pink sidebar and the dark one.

     --gradient-brand-btn is the single primary-action gradient: every primary
     button and the active nav pill resolve from it, so they can never drift
     apart. Change the colour or the angle here and the whole app follows. */
  --gradient-brand-btn: linear-gradient(180deg, #3B5BF5 0%, #22C7E8 100%);
  --gradient-nav-active: var(--gradient-brand-btn);
  --shadow-brand-btn: 0 6px 16px rgba(59, 91, 245, 0.28);
  --shadow-nav-active: var(--shadow-brand-btn);

  /* Violet→indigo accent, for brand surfaces that are deliberately NOT
     primary actions: the user avatar and the active tab underline. */
  --gradient-brand-accent: linear-gradient(90deg, #9061F9 0%, #4F5BF5 100%);

  --gradient-icon: linear-gradient(135deg, #8B5CF6 0%, #4F7DF3 55%, #22C7E8 100%);

  /* Spacing Scale */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;
  --space-16: 4rem;
  --space-20: 5rem;
  --space-24: 6rem;

  /* Border Radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.25rem;
  --radius-3xl: 1.5rem;
  --radius-full: 9999px;

  /* Typography Scale */
  --text-xs: 0.75rem;
  --text-sm: 0.8125rem;
  --text-base: 0.875rem;
  --text-md: 0.9375rem;
  --text-lg: 1rem;
  --text-xl: 1.125rem;
  --text-2xl: 1.25rem;
  --text-3xl: 1.5rem;
  --text-4xl: 1.875rem;

  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);
}

:root[data-theme='dark'] {
  --bg-primary: radial-gradient(circle at top left, #1d1b28, #050509 55%);
  --bg-secondary: radial-gradient(circle at top left, #080716, #02030a);
  --bg-card: radial-gradient(circle at top left, #141325, #05040b);
  --bg-card-flat: #0c0b14;
  --bg-header: radial-gradient(circle at top left, #181626, #0c0b12);
  --bg-input: rgba(15, 23, 42, 0.8);
  --bg-hover: radial-gradient(circle at top left, rgba(79, 70, 229, 0.2), rgba(15, 23, 42, 0.9));
  --bg-active: radial-gradient(circle at top left, rgba(129, 140, 248, 0.3), rgba(30, 64, 175, 0.8));
  --bg-subtle: rgba(79, 70, 229, 0.08);
  --bg-surface: rgba(15, 23, 42, 0.5);
  /* Lead funnel ramp — dark steps, chosen against --bg-card-flat (#0c0b14),
     not flipped from the light ones. Five ordinal steps carry pipeline depth
     for the in-flight stages; the two terminal outcomes are semantic, not part
     of the ramp. See LeadStatusBreakdown.tsx.

     The ramp runs dark→light here, the reverse of the light theme, because what
     makes a bar read as "further along" is contrast against the card, not
     darkness in the absolute: on white the deep steps stand out, on near-black
     the pale ones do. Same five validated steps either way, only the end that
     means "stage 1" changes. */
  --lead-funnel-1: #256abf;
  --lead-funnel-2: #3987e5;
  --lead-funnel-3: #6da7ec;
  --lead-funnel-4: #9ec5f4;
  --lead-funnel-5: #cde2fb;
  --lead-funnel-won: #0ca30c;
  --lead-funnel-lost: #898781;

  /* Rating stars. One teal that clears 3:1 on this theme's card — the brighter
     teal in the mock (#14b8a6) only manages 2.49:1 on white. */
  --rating-star: #2dd4bf;
  --rating-star-empty: rgba(148, 163, 184, 0.25);

  /* Status ink — for a figure that is meeting a target or missing it, never
     for a chart series. Both clear 4.5:1 on this theme's card, because they
     are read as small text and not just seen as a colour. Amber rather than
     red for "below": missing a satisfaction target is a warning to act on,
     not a failure state. */
  --status-good: #4ade80;
  --status-below: #fbbf24;

  --text-primary: #f1f5f9;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  --text-muted: #64748b;
  --text-label: #64748b;
  --text-accent: #818CF8;
  --text-accent-light: #A5B4FC;
  --border-color: rgba(55, 65, 81, 0.9);
  --border-subtle: rgba(55, 65, 81, 0.5);
  --border-hover: rgba(129, 140, 248, 0.6);
  --border-accent: rgba(79, 70, 229, 0.3);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.4);
  --shadow-glow: 0 0 32px rgba(79, 70, 229, 0.15);
  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(55, 65, 81, 0.5);
  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(129, 140, 248, 0.4);
  /* Sidebar scrollbars — indigo-tinted to match nav accents */
  --scrollbar-track: rgba(15, 23, 42, 0.45);
  --scrollbar-thumb: rgba(99, 102, 241, 0.38);
  --scrollbar-thumb-hover: rgba(129, 140, 248, 0.58);
  /* App shell (sidebar / topbar) — dark counterpart of the light pink gradient */
  --sidebar-bg: linear-gradient(180deg, #1f1b30 0%, #17132a 45%, #0c0a14 100%);
  --sidebar-border: rgba(148, 130, 255, 0.12);
  --icon-chip-bg: rgba(99, 102, 241, 0.16);
  --donut-track: rgba(148, 163, 184, 0.16);
}

:root[data-theme='light'] {
  --bg-primary: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  --bg-secondary: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  --bg-card: #ffffff;
  --bg-card-flat: #ffffff;
  --bg-header: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  --bg-input: #ffffff;
  --bg-hover: rgba(79, 70, 229, 0.06);
  --bg-active: rgba(129, 140, 248, 0.12);
  --bg-subtle: rgba(139, 92, 246, 0.06);
  --bg-surface: rgba(241, 245, 249, 0.8);
  /* Lead funnel ramp — light steps, validated against --bg-card (#ffffff). */
  --lead-funnel-1: #86b6ef;
  --lead-funnel-2: #5598e7;
  --lead-funnel-3: #2a78d6;
  --lead-funnel-4: #1c5cab;
  --lead-funnel-5: #104281;
  --lead-funnel-won: #0ca30c;
  --lead-funnel-lost: #898781;

  --rating-star: #0d9488;
  --rating-star-empty: rgba(15, 23, 42, 0.14);

  /* Status ink — see the dark theme's note. Own steps for this surface, not
     the dark pair dimmed: #4ade80 manages only 1.8:1 on white. */
  --status-good: #15803d;
  --status-below: #b45309;

  --text-primary: #0f172a;
  --text-secondary: #1e293b;
  --text-tertiary: #475569;
  --text-muted: #64748b;
  --text-label: #94a3b8;
  --text-accent: #4F46E5;
  --text-accent-light: #818CF8;
  --border-color: rgba(226, 232, 240, 0.9);
  --border-subtle: rgba(226, 232, 240, 0.5);
  --border-hover: rgba(139, 92, 246, 0.5);
  --border-accent: rgba(139, 92, 246, 0.2);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.1);
  --shadow-glow: 0 0 32px rgba(139, 92, 246, 0.1);
  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(226, 232, 240, 0.8);
  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(139, 92, 246, 0.3);
  --scrollbar-track: rgba(241, 245, 249, 0.95);
  --scrollbar-thumb: rgba(148, 163, 184, 0.55);
  --scrollbar-thumb-hover: rgba(99, 102, 241, 0.42);
  color-scheme: light;
  /* App shell (sidebar / topbar) — signature pink/lavender gradient */
  --sidebar-bg: linear-gradient(180deg, #FCEEF3 0%, #F6F1FA 45%, #FFFFFF 100%);
  --sidebar-border: rgba(37, 37, 37, 0.06);
  --icon-chip-bg: #E9EFFE;
  --donut-track: #EFEFF3;
}

/* ── Marketing pages: ALWAYS dark ─────────── */
.marketing-layout {
  --bg-primary: radial-gradient(circle at top left, #1d1b28, #050509 55%);
  --bg-secondary: radial-gradient(circle at top left, #080716, #02030a);
  --bg-card: radial-gradient(circle at top left, #141325, #05040b);
  --bg-card-flat: #0c0b14;
  --bg-header: radial-gradient(circle at top left, #181626, #0c0b12);
  --bg-input: rgba(15, 23, 42, 0.8);
  --bg-hover: radial-gradient(circle at top left, rgba(79, 70, 229, 0.2), rgba(15, 23, 42, 0.9));
  --bg-active: radial-gradient(circle at top left, rgba(129, 140, 248, 0.3), rgba(30, 64, 175, 0.8));
  --bg-subtle: rgba(79, 70, 229, 0.08);
  --bg-surface: rgba(15, 23, 42, 0.5);
  --text-primary: #f1f5f9;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  --text-muted: #64748b;
  --text-label: #64748b;
  --text-accent: #818CF8;
  --text-accent-light: #A5B4FC;
  --border-color: rgba(55, 65, 81, 0.9);
  --border-subtle: rgba(55, 65, 81, 0.5);
  --border-hover: rgba(129, 140, 248, 0.6);
  --border-accent: rgba(79, 70, 229, 0.3);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.4);
  --shadow-glow: 0 0 32px rgba(79, 70, 229, 0.15);
  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(55, 65, 81, 0.5);
  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(129, 140, 248, 0.4);
  /* Tailwind/shadcn dark values */
  --background: 222.2 84% 4.9%;
  --foreground: 210 40% 98%;
  --card: 222.2 84% 4.9%;
  --card-foreground: 210 40% 98%;
  --popover: 222.2 84% 4.9%;
  --popover-foreground: 210 40% 98%;
  --primary: 210 40% 98%;
  --primary-foreground: 222.2 47.4% 11.2%;
  --secondary: 217.2 32.6% 17.5%;
  --secondary-foreground: 210 40% 98%;
  --muted: 217.2 32.6% 17.5%;
  --muted-foreground: 215 20.2% 65.1%;
  --accent: 217.2 32.6% 17.5%;
  --accent-foreground: 210 40% 98%;
  --destructive: 0 62.8% 30.6%;
  --destructive-foreground: 210 40% 98%;
  --border: 217.2 32.6% 17.5%;
  --input: 217.2 32.6% 17.5%;
  --ring: 212.7 26.8% 83.9%;
  color-scheme: dark;
}

/* ── Theme background utilities ──────────────────────────────────────
   Several theme tokens (--bg-primary, --bg-card, --bg-hover, …) hold a
   *gradient* in the dark theme and a plain color in the light theme.
   Tailwind's \`bg-[var(--token)]\` arbitrary value compiles to
   \`background-color: var(--token)\`, and a gradient is an <image>, not a
   <color> — so that declaration is invalid and dropped, leaving the
   element fully transparent (sticky headers then show the page content
   scrolling through them).

   These classes use the \`background\` shorthand, which accepts both a
   color and a gradient, so they resolve correctly in either theme.
   Use them instead of \`bg-[var(--bg-*)]\` for these tokens. */

.bg-app-primary { background: var(--bg-primary); }
.bg-app-secondary { background: var(--bg-secondary); }
.bg-app-card { background: var(--bg-card); }
.bg-app-header { background: var(--bg-header); }
.bg-app-sidebar { background: var(--sidebar-bg); }
.bg-app-subtle { background: var(--bg-subtle); }

.hover-bg-app-hover:hover:not(:disabled) { background: var(--bg-hover); }
.bg-app-hover { background: var(--bg-hover); }
.bg-app-active { background: var(--bg-active); }

/* Radix menu/select items highlight via [data-highlighted], not :hover. */
.highlight-bg-app-hover:focus,
.highlight-bg-app-hover[data-highlighted] { background: var(--bg-hover); }

/* !important variants, for overriding base .btn / .modal-content rules. */
.bg-app-card-i { background: var(--bg-card) !important; }
.hover-bg-app-hover-i:hover:not(:disabled) { background: var(--bg-hover) !important; }

/* ── Brand gradient utilities ────────────────────────────────────────
   Same reason as the block above: these tokens hold gradients, so they
   need the \`background\` shorthand rather than \`bg-[var(--token)]\`. */

.bg-gradient-nav-active { background: var(--gradient-nav-active); }
.bg-gradient-brand-btn { background: var(--gradient-brand-btn); }
.bg-gradient-brand-accent { background: var(--gradient-brand-accent); }
.bg-gradient-icon { background: var(--gradient-icon); }
.bg-icon-chip { background: var(--icon-chip-bg); }

/* Tailwind reads \`shadow-[var(--x)]\` as a shadow *colour*, not a full
   box-shadow, so these have to be plain classes. */
.shadow-nav-active { box-shadow: var(--shadow-nav-active); }
.shadow-brand-btn { box-shadow: var(--shadow-brand-btn); }

/* Active tab underline. AnalyticsDashboard.css paints \`.tab.active::after\`
   with the flat --brand-purple; the extra \`.tab\` here keeps the gradient
   winning whichever order the two stylesheets load in. */
.tab.tab-gradient.active::after { background: var(--gradient-brand-accent); }

/* Donut background track. Recharts puts \`className\` on the <Pie> group, and a
   CSS var cannot be handed to the sector through the \`fill\` prop, so the
   colour is applied here instead. */
.donut-track .recharts-sector { fill: var(--donut-track); }

/* Gradient line icons.
   The icon set in components/Icons.tsx paints with \`stroke="currentColor"\`,
   and a gradient is not a <color>, so it cannot be handed down through
   \`color\`. Instead we point \`stroke\` at the <linearGradient> rendered once
   by <IconGradientDefs />. CSS beats the SVG presentation attribute, and
   children inherit \`stroke\` unless they set their own (the \`stroke="none"\`
   dots inside IconAgent stay unstroked, as intended). */

.icon-gradient > svg {
  /* The trailing colour is the SVG paint-server fallback: if <IconGradientDefs />
     is not mounted on this page the icon still paints flat indigo rather than
     disappearing. */
  stroke: url(#vinaIconGradient) #6F6AF8;
  color: #6F6AF8;
}

.icon-gradient > svg [fill="currentColor"] { fill: url(#vinaIconGradient) #6F6AF8; }

/* Gradient text (tab labels, emphasised numbers). */
.text-gradient-brand {
  background: var(--gradient-brand-accent);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* Sticky table headers must be opaque or rows scroll through them. */
.thead-bg-app-card thead tr,
.thead-bg-app-card thead th { background: var(--bg-card-flat); }

body {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI',
    'Inter', 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: var(--text-base);
  line-height: 1.6;
  transition: background var(--transition-base), color var(--transition-base);
}

.App {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background var(--transition-base), color var(--transition-base);
}

.project-sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(129, 140, 248, 0.12), rgba(56, 189, 248, 0.05));
  border: 1px solid rgba(129, 140, 248, 0.4);
}

.project-sidebar-header select {
  text-align: center;
  text-align-last: center;
}

.project-sidebar-header select option {
  background: var(--bg-card);
  color: var(--text-primary);
  padding: 8px 12px;
}

.project-sidebar-header select option:disabled {
  color: var(--text-muted);
}

.project-sidebar-header select option[value="create-new"] {
  font-weight: 600;
  border-top: 1px solid var(--border-color);
  margin-top: 4px;
  padding-top: 12px;
}

.project-sidebar-logo-circle {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--gradient-brand-deep);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.project-sidebar-project-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-muted);
}

.project-sidebar-project-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding-right: 4px;
  margin-right: 2px;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

/* Scrollable panels (e.g. conversation list) — same scrollbar chrome as .sidebar-nav */
.scrollbar-themed {
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  padding-right: 4px;
  margin-right: 2px;
  box-sizing: border-box;
}

.sidebar-nav::-webkit-scrollbar,
.scrollbar-themed::-webkit-scrollbar {
  width: 8px;
}

.sidebar-nav::-webkit-scrollbar-track,
.scrollbar-themed::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
  border-radius: var(--radius-full);
}

.sidebar-nav::-webkit-scrollbar-thumb,
.scrollbar-themed::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--radius-full);
  border: 2px solid transparent;
  background-clip: padding-box;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover,
.scrollbar-themed::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover);
}

.sidebar-project-switcher {
  margin-top: 8px;
  margin-bottom: 8px;
}

.sidebar-project-switcher select {
  width: 100%;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-color);
  background: var(--bg-input);
  color: var(--text-secondary);
  font-size: 13px;
  outline: none;
  transition: all 0.2s ease;
}

.sidebar-project-switcher select:focus {
  border-color: rgba(165, 180, 252, 0.9);
  box-shadow:
    0 0 0 1px rgba(129, 140, 248, 0.9),
    0 0 0 6px rgba(79, 70, 229, 0.25);
}


/* ── Mobile: sidebar becomes a slide-in drawer ────────────────── */

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--space-8) var(--space-6) var(--space-10);
}

/* Conversation History — stay within viewport on narrow screens */
.conversations-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.container.conversations-page {
  max-width: min(1280px, 100%);
}

@media (max-width: 640px) {
  .conversations-page.container {
    padding-left: var(--space-4);
    padding-right: var(--space-4);
  }
}

.conversations-page .breadcrumbs {
  flex-wrap: wrap;
  row-gap: 6px;
  min-width: 0;
}

.conversations-page .header {
  flex-wrap: wrap;
  align-items: flex-start;
  min-width: 0;
}

.conversations-page .header h1 {
  min-width: 0;
  flex: 1 1 12rem;
  font-size: clamp(1.125rem, 4.2vw, var(--text-3xl));
}

.conversations-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--space-4);
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

@media (min-width: 900px) {
  .conversations-layout {
    grid-template-columns: minmax(260px, min(38vw, 400px)) minmax(0, 1fr);
    gap: var(--space-6);
    align-items: start;
  }
}

.conversations-layout > .card {
  min-width: 0;
  max-width: 100%;
}

/* Conversation list panel — readable text on dark cards + responsive scroll */
.conversations-page .conversation-list-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  margin-bottom: var(--space-4);
}

.conversations-page .conversation-list-title {
  font-size: var(--text-xl);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

:root[data-theme='light'] .conversations-page .conversation-list-count,
:root[data-theme='light'] .conversations-page .conversation-list-msg-count {
  color: var(--text-accent);
}

.conversations-page .conversation-list-count {
  font-size: var(--text-sm);
  font-weight: 500;
  color: var(--text-accent-light);
  white-space: nowrap;
}

.conversations-page .conversation-list-filter.form-group {
  margin-bottom: var(--space-4);
}

.conversations-page .conversation-list-scroll {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-height: min(600px, calc(100vh - 260px));
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}

.conversations-page .conversation-list-scroll .conversation-list-item {
  margin-bottom: 0;
}

.conversations-page .conversation-list-item {
  padding: var(--space-4);
  width: 100%;
  box-sizing: border-box;
  border-radius: var(--radius-xl);
  text-align: left;
}

.conversations-page .conversation-list-item:focus-visible {
  outline: 2px solid var(--border-hover);
  outline-offset: 2px;
}

.conversations-page .conversation-list-item--ended {
  opacity: 0.88;
}

.conversations-page .conversation-list-row-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-3);
  margin-bottom: var(--space-2);
}

.conversations-page .conversation-list-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  min-width: 0;
}

.conversations-page .conversation-list-date {
  font-size: var(--text-xs);
  color: var(--text-tertiary);
  flex-shrink: 0;
  white-space: nowrap;
}

.conversations-page .conversation-list-msg-count {
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-accent-light);
  margin: 0 0 var(--space-2);
  letter-spacing: 0.02em;
}

.conversations-page .conversation-list-preview {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.45;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

@media (max-width: 480px) {
  .conversations-page .conversation-list-scroll {
    max-height: min(48vh, 380px);
  }
}

.conversations-page .message-bubble,
.conversations-page .chat-message-content {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.conversations-page .message {
  max-width: 100%;
}

.conversations-page .info-box {
  min-width: 0;
  max-width: 100%;
}

.header {
  background: var(--bg-header);
  border-radius: var(--radius-2xl);
  padding: var(--space-6) var(--space-8);
  margin-bottom: var(--space-6);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-card);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  transition: background var(--transition-base), border-color var(--transition-base);
}

.header h1 {
  font-size: var(--text-3xl);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  line-height: 1.3;
}

.header-subtitle {
  margin-top: var(--space-1);
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: var(--space-3);
  flex-shrink: 0;
}

.btn {
  padding: var(--space-2) var(--space-5);
  border: none;
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  white-space: nowrap;
  line-height: 1.5;
  min-height: 38px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

.btn-primary {
  background: var(--gradient-brand-btn);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(59, 91, 245, 0.4), 0 0 0 1px rgba(59, 91, 245, 0.3);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 91, 245, 0.5), 0 0 0 1px rgba(34, 199, 232, 0.5);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-secondary {
  background: var(--bg-input);
  color: var(--text-secondary);
  box-shadow: 0 0 0 1px var(--border-color);
  transition: all var(--transition-fast);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--bg-hover);
  box-shadow: 0 0 0 1px var(--border-hover);
  color: var(--text-primary);
}

.btn-danger {
  background: linear-gradient(135deg, #EF4444, #DC2626);
  color: #FEE2E2;
  box-shadow: 0 1px 3px rgba(239, 68, 68, 0.3), 0 0 0 1px rgba(248, 113, 113, 0.4);
}

.btn-danger:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4), 0 0 0 1px rgba(248, 113, 113, 0.6);
}

.btn-ghost {
  background: transparent;
  color: var(--text-muted);
  box-shadow: none;
}

.btn-ghost:hover:not(:disabled) {
  background: var(--bg-subtle);
  color: var(--text-secondary);
}

.btn-sm {
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-xs);
  min-height: 30px;
  border-radius: var(--radius-md);
}

.btn-lg {
  padding: var(--space-3) var(--space-8);
  font-size: var(--text-md);
  min-height: 44px;
}

.btn-block {
  width: 100%;
}

.card {
  background: var(--bg-card);
  border-radius: var(--radius-2xl);
  padding: var(--space-6);
  margin-bottom: var(--space-5);
  box-shadow: var(--shadow-card);
  border: 1px solid var(--border-color);
  transition: all var(--transition-base);
}

.card h2,
.card h3 {
  color: var(--text-primary);
}

.card-title {
  font-size: var(--text-2xl);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--space-2);
  letter-spacing: -0.01em;
}

.automation-form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.automation-form-grid-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--space-4);
}

@media (max-width: 640px) {
  .automation-form-grid-2,
  .automation-form-grid-3 {
    grid-template-columns: 1fr;
  }
}

.card-subtitle {
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: var(--space-6);
}

.card-interactive {
  cursor: pointer;
}

.card-interactive:hover {
  border-color: var(--border-hover);
  box-shadow: var(--shadow-card-hover);
  transform: translateY(-2px);
}

.card-interactive:active {
  transform: translateY(0);
}

.card-highlighted {
  border: 1.5px solid var(--border-accent);
  background: var(--bg-subtle);
}

.card-success {
  border: 1.5px solid rgba(34, 197, 94, 0.3);
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.04) 0%, rgba(139, 92, 246, 0.04) 100%);
}

.form-group {
  margin-bottom: var(--space-5);
}

.form-group label {
  display: block;
  margin-bottom: var(--space-2);
  font-weight: 500;
  font-size: var(--text-sm);
  color: var(--text-tertiary);
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  font-size: var(--text-base);
  font-family: inherit;
  background: var(--bg-input);
  color: var(--text-secondary);
  outline: none;
  transition: all var(--transition-fast);
  line-height: 1.5;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: var(--border-hover);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.form-group input:disabled,
.form-group textarea:disabled,
.form-group select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-label-uppercase {
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: var(--space-2);
  display: block;
}

.form-hint {
  font-size: var(--text-xs);
  color: var(--text-muted);
  margin-top: var(--space-1);
  line-height: 1.5;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.status-active {
  background: rgba(34, 197, 94, 0.18);
  color: #6ee7b7;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.45);
}

.status-inactive {
  background-color: rgba(239, 68, 68, 0.18);
  color: #fecaca;
  box-shadow: 0 0 0 1px rgba(248, 113, 113, 0.6);
}

.status-processing {
  background-color: rgba(59, 130, 246, 0.18);
  color: #bfdbfe;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);
}

.status-ready {
  background-color: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.55);
}

.status-connected {
  background-color: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
  box-shadow: 0 0 0 1px rgba(74, 222, 128, 0.6);
}

.status-disconnected {
  background-color: rgba(248, 113, 113, 0.22);
  color: #fecaca;
  box-shadow: 0 0 0 1px rgba(248, 113, 113, 0.7);
}

.status-draft {
  background-color: rgba(107, 114, 128, 0.18);
  color: #d1d5db;
  box-shadow: 0 0 0 1px rgba(107, 114, 128, 0.5);
}

.status-training {
  background-color: rgba(59, 130, 246, 0.18);
  color: #bfdbfe;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);
}

.status-live {
  background-color: rgba(34, 197, 94, 0.18);
  color: #6ee7b7;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.45);
}

.status-paused {
  background-color: rgba(245, 158, 11, 0.18);
  color: #fde68a;
  box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.5);
}

:root[data-theme='light'] .status-active,
:root[data-theme='light'] .status-live,
:root[data-theme='light'] .status-ready,
:root[data-theme='light'] .status-connected {
  color: #15803d;
}

:root[data-theme='light'] .status-inactive,
:root[data-theme='light'] .status-disconnected {
  color: #b91c1c;
}

:root[data-theme='light'] .status-processing,
:root[data-theme='light'] .status-training {
  color: #1d4ed8;
}

:root[data-theme='light'] .status-draft {
  color: #374151;
}

:root[data-theme='light'] .status-paused {
  color: #92400e;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

:root[data-theme='light'] .modal-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: var(--bg-card);
  border-radius: 18px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-color);
  transition: background 0.3s ease, border-color 0.3s ease;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: var(--text-secondary);
}

.grid {
  display: grid;
  gap: 16px;
}

.grid-2 {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.grid-3 {
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
}

.tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: var(--space-6);
  gap: var(--space-1);
}

.tab {
  padding: var(--space-3) var(--space-5);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: -1px;
  transition: all var(--transition-fast);
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.tab.active {
  color: var(--text-accent);
  border-bottom-color: var(--brand-purple);
}

.tab:hover:not(.active):not(:disabled) {
  color: var(--text-secondary);
  background: var(--bg-subtle);
}

.tab:disabled,
.tab.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: rgba(31, 41, 55, 0.95);
  outline: none;
  appearance: none;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--brand-purple-deep);
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--brand-purple-deep);
  cursor: pointer;
  border: none;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #4b5563;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.toggle-slider {
  background-color: var(--brand-purple-deep);
}

input:checked+.toggle-slider:before {
  transform: translateX(24px);
}

.code-block {
  background: var(--bg-input);
  color: var(--text-secondary);
  padding: 16px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  overflow-x: auto;
  margin: 16px 0;
  border: 1px solid var(--border-color);
  transition: background 0.3s ease, border-color 0.3s ease;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 600px;
  background: var(--bg-card);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  transition: background 0.3s ease, border-color 0.3s ease;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: transparent;
}

.message {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.message.user {
  align-items: flex-end;
}

.message.agent {
  align-items: flex-start;
}

.message-bubble {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 12px;
  word-wrap: break-word;
}

.message.user .message-bubble {
  background: var(--gradient-brand-deep);
  color: #f9fafb;
  border-bottom-right-radius: 4px;
}

.message.agent .message-bubble {
  background-color: var(--bg-input);
  color: var(--text-secondary);
  border-bottom-left-radius: 4px;
  box-shadow: var(--shadow-sm);
}

.message-sender {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.chat-input-container {
  padding: 16px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-input);
  display: flex;
  gap: 12px;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.chat-input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  font-size: 14px;
  background: var(--bg-card);
  color: var(--text-secondary);
  transition: all 0.2s ease;
}

.chat-input:focus {
  outline: none;
  border-color: rgba(129, 140, 248, 1);
  box-shadow:
    0 0 0 1px rgba(129, 140, 248, 1),
    0 0 0 8px rgba(79, 70, 229, 0.28);
}

/* Auth Layout Styles */
.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-primary);
  padding: 20px;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  background: var(--bg-card);
  border-radius: 20px;
  padding: 40px;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-color);
}

.auth-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
  text-align: center;
}

.auth-subtitle {
  font-size: 15px;
  color: var(--text-muted);
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.5;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.auth-footer {
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  color: var(--text-muted);
}

.auth-link {
  color: var(--brand-purple);
  text-decoration: none;
  font-weight: 600;
  transition: color var(--transition-fast);
}

.auth-link:hover {
  color: var(--brand-purple-deep);
  text-decoration: underline;
}

/* ============================================
   APP COMPONENT PATTERNS
   ============================================ */

/* ── Info/Tip Boxes ─────────────────────── */
.info-box {
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
  line-height: 1.6;
}

.info-box-purple {
  background: rgba(79, 70, 229, 0.08);
  border: 1px solid rgba(79, 70, 229, 0.2);
  color: var(--brand-purple);
}

.info-box-blue {
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  color: var(--color-info);
}

.info-box-success {
  background: rgba(34, 197, 94, 0.08);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: var(--color-success);
}

.info-box-error {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: var(--color-error);
}

/* ── Empty State ────────────────────────── */
.empty-state {
  text-align: center;
  padding: var(--space-16) var(--space-8);
}

.empty-state-icon {
  font-size: 3rem;
  margin-bottom: var(--space-5);
  opacity: 0.6;
}

.empty-state-title {
  font-size: var(--text-3xl);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--space-3);
  letter-spacing: -0.02em;
}

.empty-state-desc {
  font-size: var(--text-md);
  color: var(--text-muted);
  max-width: 480px;
  margin: 0 auto var(--space-8);
  line-height: 1.7;
}


/* ── Avatar ─────────────────────────────── */
.avatar {
  border-radius: var(--radius-full);
  overflow: hidden;
  background: var(--bg-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-sm {
  width: 32px;
  height: 32px;
  font-size: var(--text-sm);
}

.avatar-md {
  width: 48px;
  height: 48px;
  font-size: var(--text-xl);
}

.avatar-lg {
  width: 64px;
  height: 64px;
  font-size: var(--text-3xl);
}

.avatar-xl {
  width: 96px;
  height: 96px;
  font-size: 2.5rem;
}

.avatar-initial {
  font-weight: 700;
  color: var(--text-primary);
}

/* ── Detail Grid ────────────────────────── */
.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-4);
}

@media (max-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.detail-value {
  font-size: var(--text-md);
  color: var(--text-secondary);
  line-height: 1.6;
}

/* ── Display Field (read-only styled box) ── */

.display-field {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-lg);
  background: var(--bg-input);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: var(--text-md);
  line-height: 1.6;
}

.display-field-lg {
  min-height: 80px;
  white-space: pre-wrap;
}

/* ── Value Badge (small colored pill) ────── */

.value-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-size: var(--text-sm);
  font-weight: 500;
  background: rgba(79, 70, 229, 0.15);
  color: var(--brand-purple);
  border: 1px solid rgba(79, 70, 229, 0.2);
}

/* ── Status Pill Selector ───────────────── */
.status-selector {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.status-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-2) var(--space-4);
  min-width: 100px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  background: var(--bg-input);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: inherit;
}

.status-option:hover:not(:disabled) {
  border-color: var(--border-hover);
}

.status-option.active {
  background: var(--gradient-brand-deep);
  color: #f1f5f9;
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3);
}

.status-option:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.status-option-label {
  font-weight: 600;
  font-size: var(--text-sm);
}

.status-option-desc {
  font-size: var(--text-xs);
  opacity: 0.8;
  margin-top: 2px;
}

/* ── Code Embed Tabs ────────────────────── */
.embed-tabs {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
  margin-bottom: var(--space-3);
}

.embed-tab {
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  background: var(--bg-input);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: var(--text-xs);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: inherit;
}

.embed-tab:hover {
  border-color: var(--border-hover);
}

.embed-tab.active {
  border-color: var(--brand-purple);
  background: rgba(79, 70, 229, 0.12);
  color: var(--brand-purple);
}

/* ── WhatsApp Account Card ──────────────── */
.whatsapp-account-card {
  padding: var(--space-4);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-3);
  background: var(--bg-subtle);
  transition: all var(--transition-fast);
}

.whatsapp-account-card:hover {
  border-color: var(--border-hover);
}

/* ── Dashed Add Card ────────────────────── */
.add-card-dashed {
  padding: var(--space-4);
  border: 2px dashed var(--border-accent);
  border-radius: var(--radius-lg);
  margin-top: var(--space-6);
  transition: all var(--transition-fast);
}

.add-card-dashed:hover {
  border-color: var(--border-hover);
}

/* ── Stats Row ──────────────────────────── */
.stats-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: var(--space-5);
  background: var(--bg-surface);
  border-radius: var(--radius-2xl);
  border: 1px solid var(--border-subtle);
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: var(--text-4xl);
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
}

.stat-label {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-top: var(--space-1);
}

/* ── Step Instructions ──────────────────── */
.steps-list {
  padding-left: var(--space-5);
  color: var(--text-accent-light);
  line-height: 2;
  font-size: var(--text-sm);
}

.steps-list li {
  margin-bottom: var(--space-2);
}

/* ── Workspace Card ─────────────────────── */
.workspace-card {
  cursor: pointer;
  padding: var(--space-6);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  border: 1px solid var(--border-color);
  background: var(--bg-card);
  transition: all var(--transition-fast);
}

.workspace-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-card-hover);
  border-color: var(--border-hover);
}

.workspace-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--space-4);
}

.workspace-card-name {
  font-size: var(--text-xl);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.workspace-card-footer {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-subtle);
}

/* ── Grid Layouts ───────────────────────── */
.grid-auto {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

/* ============================================
   CHANNELS PAGE
   ============================================ */

/* Live Banner */
/* ── Channels Page: Overview Mode ──────────────── */
.channels-row-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.channel-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) var(--space-5);
  border-radius: var(--radius-xl);
  border: 1.5px solid var(--border-color);
  background: var(--bg-card);
  transition: border-color 0.2s ease;
}

.channel-row:hover {
  border-color: var(--border-hover);
}

.channel-row-left {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.channel-row-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.channel-row-icon.web {
  background: rgba(79, 70, 229, 0.12);
  color: #818cf8;
}

.channel-row-icon.whatsapp {
  background: rgba(59, 130, 246, 0.12);
  color: #60a5fa;
}

.channel-row-icon.voice {
  background: rgba(129, 140, 248, 0.12);
  color: #818cf8;
}

.channel-row-name {
  font-size: var(--text-md);
  font-weight: 600;
  color: var(--text-primary);
}

.channel-row-right {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.channel-row-status {
  font-size: var(--text-sm);
  font-weight: 500;
  color: var(--text-muted);
  min-width: 52px;
}

.channel-row-status.active {
  color: var(--text-primary);
}

.btn-configure:active {
  transform: translateY(0);
}

/* ── Channels Page: Configure Top Bar ──────────── */
.channel-config-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) var(--space-5);
  border-radius: var(--radius-xl);
  border: 1.5px solid var(--border-color);
  background: var(--bg-card);
  margin-bottom: var(--space-5);
}

.channel-config-topbar-left {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.channel-config-topbar-name {
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--text-primary);
}

.channel-config-topbar-right {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

/* Responsive */
@media (max-width: 640px) {
  .channel-row {
    flex-direction: column;
    gap: var(--space-3);
    align-items: flex-start;
  }

  .channel-row-right {
    width: 100%;
    justify-content: flex-end;
  }

  .channel-config-topbar {
    flex-direction: column;
    gap: var(--space-3);
    align-items: flex-start;
  }

  .channel-config-topbar-right {
    width: 100%;
    justify-content: flex-end;
  }
}

/* ============================================
   SIDEBAR USER MENU
   ============================================ */
/* ── Support Ticket Chat History Markdown Styles ───────────────── */
.chat-message-content {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.chat-message-content p {
  margin: 0 0 8px 0;
}

.chat-message-content p:last-child {
  margin-bottom: 0;
}

.chat-message-content h1,
.chat-message-content h2,
.chat-message-content h3,
.chat-message-content h4,
.chat-message-content h5,
.chat-message-content h6 {
  margin: 12px 0 8px 0;
  font-weight: 600;
  line-height: 1.3;
  color: var(--text-primary);
}

.chat-message-content h1:first-child,
.chat-message-content h2:first-child,
.chat-message-content h3:first-child,
.chat-message-content h4:first-child,
.chat-message-content h5:first-child,
.chat-message-content h6:first-child {
  margin-top: 0;
}

.chat-message-content h1 {
  font-size: 1.5em;
}

.chat-message-content h2 {
  font-size: 1.3em;
}

.chat-message-content h3 {
  font-size: 1.1em;
}

.chat-message-content ul,
.chat-message-content ol {
  margin: 8px 0;
  padding-left: 24px;
}

.chat-message-content li {
  margin: 4px 0;
  line-height: 1.5;
}

.chat-message-content code {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9em;
  color: var(--text-primary);
}

:root[data-theme='dark'] .chat-message-content code {
  background: rgba(255, 255, 255, 0.15);
}

.chat-message-content pre {
  background: rgba(0, 0, 0, 0.05);
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 8px 0;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9em;
  line-height: 1.4;
}

:root[data-theme='dark'] .chat-message-content pre {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.chat-message-content pre code {
  background: none;
  padding: 0;
}

.chat-message-content blockquote {
  border-left: 3px solid rgba(0, 0, 0, 0.2);
  padding-left: 12px;
  margin: 8px 0;
  color: var(--text-muted);
  font-style: italic;
}

:root[data-theme='dark'] .chat-message-content blockquote {
  border-left-color: rgba(255, 255, 255, 0.3);
}

.chat-message-content a {
  color: var(--brand-blue);
  text-decoration: underline;
  word-break: break-all;
}

.chat-message-content a:hover {
  opacity: 0.8;
}

.chat-message-content strong {
  font-weight: 600;
}

.chat-message-content em {
  font-style: italic;
}

.chat-message-content hr {
  border: none;
  border-top: 1px solid var(--border-primary);
  margin: 12px 0;
}

/* ============================================
   LOADER COMPONENT
   ============================================ */

.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
  /* Ensure visibility */
}

.loader {
  display: flex;
  gap: 10px;
}

.loader span {
  height: 20px;
  width: 20px;
  background-image: var(--gradient-brand-deep);
  border-radius: 50%;
  animation-name: animar;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  box-shadow: var(--shadow-lg);
}

#one {
  animation-delay: 1s;
}

#two {
  animation-delay: 2s;
}

#three {
  animation-delay: 3s;
}

@keyframes animar {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  33% {
    transform: scale(.3);
    opacity: 0.7;
  }

  66% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;iDAGiD;;AAEjD;EACE,iEAAiE;EACjE,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;;EAEtB,oBAAoB;EACpB,wBAAwB;EACxB,8CAA8C;EAC9C,sBAAsB;EACtB,4CAA4C;EAC5C,wBAAwB;EACxB,+CAA+C;EAC/C,qBAAqB;EACrB,4CAA4C;;EAE5C,cAAc;EACd,mEAAmE;EACnE,wEAAwE;EACxE,kEAAkE;;EAElE;;;;;4EAK0E;EAC1E,uEAAuE;EACvE,gDAAgD;EAChD,sDAAsD;EACtD,4CAA4C;;EAE5C;qEACmE;EACnE,yEAAyE;;EAEzE,+EAA+E;;EAE/E,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;;EAErB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;;EAEpB,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,uEAAuE;EACvE,qEAAqE;EACrE,gEAAgE;EAChE,uBAAuB;EACvB,kEAAkE;EAClE,iCAAiC;EACjC,8FAA8F;EAC9F,kGAAkG;EAClG,oCAAoC;EACpC,mCAAmC;EACnC;;;;;;;;;+BAS6B;EAC7B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;;EAE3B;+DAC6D;EAC7D,sBAAsB;EACtB,8CAA8C;;EAE9C;;;;2BAIyB;EACzB,sBAAsB;EACtB,uBAAuB;;EAEvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,+CAA+C;EAC/C,4EAA4E;EAC5E,sFAAsF;EACtF,4DAA4D;EAC5D,yCAAyC;EACzC,2CAA2C;EAC3C,kDAAkD;EAClD,+EAA+E;EAC/E,4EAA4E;EAC5E,2CAA2C;EAC3C,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,+DAA+D;EAC/D,iEAAiE;EACjE,kBAAkB;EAClB,uBAAuB;EACvB,8DAA8D;EAC9D,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;EACtC,2EAA2E;EAC3E,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;;EAE3B,sBAAsB;EACtB,2CAA2C;;EAE3C;iEAC+D;EAC/D,sBAAsB;EACtB,uBAAuB;;EAEvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,wCAAwC;EACxC,yCAAyC;EACzC,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,+CAA+C;EAC/C,gFAAgF;EAChF,sFAAsF;EACtF,4CAA4C;EAC5C,4CAA4C;EAC5C,iDAAiD;EACjD,mBAAmB;EACnB,oEAAoE;EACpE,4EAA4E;EAC5E,wCAAwC;EACxC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,uEAAuE;EACvE,qEAAqE;EACrE,gEAAgE;EAChE,uBAAuB;EACvB,kEAAkE;EAClE,iCAAiC;EACjC,8FAA8F;EAC9F,kGAAkG;EAClG,oCAAoC;EACpC,mCAAmC;EACnC,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,+CAA+C;EAC/C,4EAA4E;EAC5E,sFAAsF;EACtF,gCAAgC;EAChC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,qCAAqC;EACrC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;6DAW6D;;AAE7D,kBAAkB,6BAA6B,EAAE;AACjD,oBAAoB,+BAA+B,EAAE;AACrD,eAAe,0BAA0B,EAAE;AAC3C,iBAAiB,4BAA4B,EAAE;AAC/C,kBAAkB,6BAA6B,EAAE;AACjD,iBAAiB,4BAA4B,EAAE;;AAE/C,2CAA2C,2BAA2B,EAAE;AACxE,gBAAgB,2BAA2B,EAAE;AAC7C,iBAAiB,4BAA4B,EAAE;;AAE/C,0EAA0E;AAC1E;4CAC4C,2BAA2B,EAAE;;AAEzE,0EAA0E;AAC1E,iBAAiB,qCAAqC,EAAE;AACxD,6CAA6C,sCAAsC,EAAE;;AAErF;;qEAEqE;;AAErE,0BAA0B,sCAAsC,EAAE;AAClE,yBAAyB,qCAAqC,EAAE;AAChE,4BAA4B,wCAAwC,EAAE;AACtE,oBAAoB,gCAAgC,EAAE;AACtD,gBAAgB,+BAA+B,EAAE;;AAEjD;mDACmD;AACnD,qBAAqB,oCAAoC,EAAE;AAC3D,oBAAoB,mCAAmC,EAAE;;AAEzD;;yDAEyD;AACzD,kCAAkC,wCAAwC,EAAE;;AAE5E;;oCAEoC;AACpC,gCAAgC,wBAAwB,EAAE;;AAE1D;;;;;;wDAMwD;;AAExD;EACE;;oBAEkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,6CAA6C,oCAAoC,EAAE;;AAEnF,oDAAoD;AACpD;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;8BAC8B,+BAA+B,EAAE;;AAE/D;EACE;iCAC+B;EAC/B,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,wFAAwF;EACxF,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA,uFAAuF;AACvF;EACE,wBAAwB;EACxB,qBAAqB;EACrB,8DAA8D;EAC9D,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;EAEE,wCAAwC;EACxC,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC;;qCAEmC;AACrC;;;AAGA,oEAAoE;;AAEpE;EACE,iBAAiB;EACjB,cAAc;EACd,sDAAsD;AACxD;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,qEAAqE;IACrE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,sCAAsC;EACtC,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,8FAA8F;AAChG;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;EAGE,WAAW;EACX,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,6CAA6C;AAC/C;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EAEb,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC;;qCAEmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;;AAGA,8CAA8C;AAC9C;EACE,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,+CAA+C;;AAE/C;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,+CAA+C;;AAE/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,qCAAqC;EACrC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;;iDAEiD;;AAEjD,gBAAgB;AAChB,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;AACjD,qEAAqE;AACrE;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   VINA AI UNIFIED DESIGN SYSTEM\n   Bridging marketing site + web application\n   ============================================ */\n\n:root {\n  /* Brand Colors - Updated to match menu selection (Indigo/Blue) */\n  --brand-purple: #818CF8;\n  --brand-purple-deep: #4F46E5;\n  --brand-blue: #60A5FA;\n  --brand-blue-deep: #2563EB;\n  --brand-green: #34D399;\n  --brand-pink: #F472B6;\n  --brand-amber: #FBBF24;\n\n  /* Semantic Colors */\n  --color-success: #34D399;\n  --color-success-muted: rgba(34, 197, 94, 0.15);\n  --color-error: #F87171;\n  --color-error-muted: rgba(239, 68, 68, 0.15);\n  --color-warning: #FBBF24;\n  --color-warning-muted: rgba(245, 158, 11, 0.15);\n  --color-info: #60A5FA;\n  --color-info-muted: rgba(59, 130, 246, 0.15);\n\n  /* Gradients */\n  --gradient-brand: linear-gradient(135deg, #818CF8 0%, #60A5FA 100%);\n  --gradient-brand-deep: linear-gradient(135deg, #4F46E5 0%, #2563EB 100%);\n  --gradient-hero: linear-gradient(135deg, #4F46E5 0%, #2563EB 100%);\n\n  /* App-shell gradients. Theme-independent, so they read the same on the light\n     pink sidebar and the dark one.\n\n     --gradient-brand-btn is the single primary-action gradient: every primary\n     button and the active nav pill resolve from it, so they can never drift\n     apart. Change the colour or the angle here and the whole app follows. */\n  --gradient-brand-btn: linear-gradient(180deg, #3B5BF5 0%, #22C7E8 100%);\n  --gradient-nav-active: var(--gradient-brand-btn);\n  --shadow-brand-btn: 0 6px 16px rgba(59, 91, 245, 0.28);\n  --shadow-nav-active: var(--shadow-brand-btn);\n\n  /* Violet→indigo accent, for brand surfaces that are deliberately NOT\n     primary actions: the user avatar and the active tab underline. */\n  --gradient-brand-accent: linear-gradient(90deg, #9061F9 0%, #4F5BF5 100%);\n\n  --gradient-icon: linear-gradient(135deg, #8B5CF6 0%, #4F7DF3 55%, #22C7E8 100%);\n\n  /* Spacing Scale */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n  --space-20: 5rem;\n  --space-24: 6rem;\n\n  /* Border Radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.25rem;\n  --radius-3xl: 1.5rem;\n  --radius-full: 9999px;\n\n  /* Typography Scale */\n  --text-xs: 0.75rem;\n  --text-sm: 0.8125rem;\n  --text-base: 0.875rem;\n  --text-md: 0.9375rem;\n  --text-lg: 1rem;\n  --text-xl: 1.125rem;\n  --text-2xl: 1.25rem;\n  --text-3xl: 1.5rem;\n  --text-4xl: 1.875rem;\n\n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n:root[data-theme='dark'] {\n  --bg-primary: radial-gradient(circle at top left, #1d1b28, #050509 55%);\n  --bg-secondary: radial-gradient(circle at top left, #080716, #02030a);\n  --bg-card: radial-gradient(circle at top left, #141325, #05040b);\n  --bg-card-flat: #0c0b14;\n  --bg-header: radial-gradient(circle at top left, #181626, #0c0b12);\n  --bg-input: rgba(15, 23, 42, 0.8);\n  --bg-hover: radial-gradient(circle at top left, rgba(79, 70, 229, 0.2), rgba(15, 23, 42, 0.9));\n  --bg-active: radial-gradient(circle at top left, rgba(129, 140, 248, 0.3), rgba(30, 64, 175, 0.8));\n  --bg-subtle: rgba(79, 70, 229, 0.08);\n  --bg-surface: rgba(15, 23, 42, 0.5);\n  /* Lead funnel ramp — dark steps, chosen against --bg-card-flat (#0c0b14),\n     not flipped from the light ones. Five ordinal steps carry pipeline depth\n     for the in-flight stages; the two terminal outcomes are semantic, not part\n     of the ramp. See LeadStatusBreakdown.tsx.\n\n     The ramp runs dark→light here, the reverse of the light theme, because what\n     makes a bar read as \"further along\" is contrast against the card, not\n     darkness in the absolute: on white the deep steps stand out, on near-black\n     the pale ones do. Same five validated steps either way, only the end that\n     means \"stage 1\" changes. */\n  --lead-funnel-1: #256abf;\n  --lead-funnel-2: #3987e5;\n  --lead-funnel-3: #6da7ec;\n  --lead-funnel-4: #9ec5f4;\n  --lead-funnel-5: #cde2fb;\n  --lead-funnel-won: #0ca30c;\n  --lead-funnel-lost: #898781;\n\n  /* Rating stars. One teal that clears 3:1 on this theme's card — the brighter\n     teal in the mock (#14b8a6) only manages 2.49:1 on white. */\n  --rating-star: #2dd4bf;\n  --rating-star-empty: rgba(148, 163, 184, 0.25);\n\n  /* Status ink — for a figure that is meeting a target or missing it, never\n     for a chart series. Both clear 4.5:1 on this theme's card, because they\n     are read as small text and not just seen as a colour. Amber rather than\n     red for \"below\": missing a satisfaction target is a warning to act on,\n     not a failure state. */\n  --status-good: #4ade80;\n  --status-below: #fbbf24;\n\n  --text-primary: #f1f5f9;\n  --text-secondary: #cbd5e1;\n  --text-tertiary: #94a3b8;\n  --text-muted: #64748b;\n  --text-label: #64748b;\n  --text-accent: #818CF8;\n  --text-accent-light: #A5B4FC;\n  --border-color: rgba(55, 65, 81, 0.9);\n  --border-subtle: rgba(55, 65, 81, 0.5);\n  --border-hover: rgba(129, 140, 248, 0.6);\n  --border-accent: rgba(79, 70, 229, 0.3);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);\n  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.4);\n  --shadow-glow: 0 0 32px rgba(79, 70, 229, 0.15);\n  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(55, 65, 81, 0.5);\n  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(129, 140, 248, 0.4);\n  /* Sidebar scrollbars — indigo-tinted to match nav accents */\n  --scrollbar-track: rgba(15, 23, 42, 0.45);\n  --scrollbar-thumb: rgba(99, 102, 241, 0.38);\n  --scrollbar-thumb-hover: rgba(129, 140, 248, 0.58);\n  /* App shell (sidebar / topbar) — dark counterpart of the light pink gradient */\n  --sidebar-bg: linear-gradient(180deg, #1f1b30 0%, #17132a 45%, #0c0a14 100%);\n  --sidebar-border: rgba(148, 130, 255, 0.12);\n  --icon-chip-bg: rgba(99, 102, 241, 0.16);\n  --donut-track: rgba(148, 163, 184, 0.16);\n}\n\n:root[data-theme='light'] {\n  --bg-primary: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  --bg-secondary: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  --bg-card: #ffffff;\n  --bg-card-flat: #ffffff;\n  --bg-header: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  --bg-input: #ffffff;\n  --bg-hover: rgba(79, 70, 229, 0.06);\n  --bg-active: rgba(129, 140, 248, 0.12);\n  --bg-subtle: rgba(139, 92, 246, 0.06);\n  --bg-surface: rgba(241, 245, 249, 0.8);\n  /* Lead funnel ramp — light steps, validated against --bg-card (#ffffff). */\n  --lead-funnel-1: #86b6ef;\n  --lead-funnel-2: #5598e7;\n  --lead-funnel-3: #2a78d6;\n  --lead-funnel-4: #1c5cab;\n  --lead-funnel-5: #104281;\n  --lead-funnel-won: #0ca30c;\n  --lead-funnel-lost: #898781;\n\n  --rating-star: #0d9488;\n  --rating-star-empty: rgba(15, 23, 42, 0.14);\n\n  /* Status ink — see the dark theme's note. Own steps for this surface, not\n     the dark pair dimmed: #4ade80 manages only 1.8:1 on white. */\n  --status-good: #15803d;\n  --status-below: #b45309;\n\n  --text-primary: #0f172a;\n  --text-secondary: #1e293b;\n  --text-tertiary: #475569;\n  --text-muted: #64748b;\n  --text-label: #94a3b8;\n  --text-accent: #4F46E5;\n  --text-accent-light: #818CF8;\n  --border-color: rgba(226, 232, 240, 0.9);\n  --border-subtle: rgba(226, 232, 240, 0.5);\n  --border-hover: rgba(139, 92, 246, 0.5);\n  --border-accent: rgba(139, 92, 246, 0.2);\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.1);\n  --shadow-glow: 0 0 32px rgba(139, 92, 246, 0.1);\n  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(226, 232, 240, 0.8);\n  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(139, 92, 246, 0.3);\n  --scrollbar-track: rgba(241, 245, 249, 0.95);\n  --scrollbar-thumb: rgba(148, 163, 184, 0.55);\n  --scrollbar-thumb-hover: rgba(99, 102, 241, 0.42);\n  color-scheme: light;\n  /* App shell (sidebar / topbar) — signature pink/lavender gradient */\n  --sidebar-bg: linear-gradient(180deg, #FCEEF3 0%, #F6F1FA 45%, #FFFFFF 100%);\n  --sidebar-border: rgba(37, 37, 37, 0.06);\n  --icon-chip-bg: #E9EFFE;\n  --donut-track: #EFEFF3;\n}\n\n/* ── Marketing pages: ALWAYS dark ─────────── */\n.marketing-layout {\n  --bg-primary: radial-gradient(circle at top left, #1d1b28, #050509 55%);\n  --bg-secondary: radial-gradient(circle at top left, #080716, #02030a);\n  --bg-card: radial-gradient(circle at top left, #141325, #05040b);\n  --bg-card-flat: #0c0b14;\n  --bg-header: radial-gradient(circle at top left, #181626, #0c0b12);\n  --bg-input: rgba(15, 23, 42, 0.8);\n  --bg-hover: radial-gradient(circle at top left, rgba(79, 70, 229, 0.2), rgba(15, 23, 42, 0.9));\n  --bg-active: radial-gradient(circle at top left, rgba(129, 140, 248, 0.3), rgba(30, 64, 175, 0.8));\n  --bg-subtle: rgba(79, 70, 229, 0.08);\n  --bg-surface: rgba(15, 23, 42, 0.5);\n  --text-primary: #f1f5f9;\n  --text-secondary: #cbd5e1;\n  --text-tertiary: #94a3b8;\n  --text-muted: #64748b;\n  --text-label: #64748b;\n  --text-accent: #818CF8;\n  --text-accent-light: #A5B4FC;\n  --border-color: rgba(55, 65, 81, 0.9);\n  --border-subtle: rgba(55, 65, 81, 0.5);\n  --border-hover: rgba(129, 140, 248, 0.6);\n  --border-accent: rgba(79, 70, 229, 0.3);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);\n  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.4);\n  --shadow-glow: 0 0 32px rgba(79, 70, 229, 0.15);\n  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(55, 65, 81, 0.5);\n  --shadow-card-hover: 0 8px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(129, 140, 248, 0.4);\n  /* Tailwind/shadcn dark values */\n  --background: 222.2 84% 4.9%;\n  --foreground: 210 40% 98%;\n  --card: 222.2 84% 4.9%;\n  --card-foreground: 210 40% 98%;\n  --popover: 222.2 84% 4.9%;\n  --popover-foreground: 210 40% 98%;\n  --primary: 210 40% 98%;\n  --primary-foreground: 222.2 47.4% 11.2%;\n  --secondary: 217.2 32.6% 17.5%;\n  --secondary-foreground: 210 40% 98%;\n  --muted: 217.2 32.6% 17.5%;\n  --muted-foreground: 215 20.2% 65.1%;\n  --accent: 217.2 32.6% 17.5%;\n  --accent-foreground: 210 40% 98%;\n  --destructive: 0 62.8% 30.6%;\n  --destructive-foreground: 210 40% 98%;\n  --border: 217.2 32.6% 17.5%;\n  --input: 217.2 32.6% 17.5%;\n  --ring: 212.7 26.8% 83.9%;\n  color-scheme: dark;\n}\n\n/* ── Theme background utilities ──────────────────────────────────────\n   Several theme tokens (--bg-primary, --bg-card, --bg-hover, …) hold a\n   *gradient* in the dark theme and a plain color in the light theme.\n   Tailwind's `bg-[var(--token)]` arbitrary value compiles to\n   `background-color: var(--token)`, and a gradient is an <image>, not a\n   <color> — so that declaration is invalid and dropped, leaving the\n   element fully transparent (sticky headers then show the page content\n   scrolling through them).\n\n   These classes use the `background` shorthand, which accepts both a\n   color and a gradient, so they resolve correctly in either theme.\n   Use them instead of `bg-[var(--bg-*)]` for these tokens. */\n\n.bg-app-primary { background: var(--bg-primary); }\n.bg-app-secondary { background: var(--bg-secondary); }\n.bg-app-card { background: var(--bg-card); }\n.bg-app-header { background: var(--bg-header); }\n.bg-app-sidebar { background: var(--sidebar-bg); }\n.bg-app-subtle { background: var(--bg-subtle); }\n\n.hover-bg-app-hover:hover:not(:disabled) { background: var(--bg-hover); }\n.bg-app-hover { background: var(--bg-hover); }\n.bg-app-active { background: var(--bg-active); }\n\n/* Radix menu/select items highlight via [data-highlighted], not :hover. */\n.highlight-bg-app-hover:focus,\n.highlight-bg-app-hover[data-highlighted] { background: var(--bg-hover); }\n\n/* !important variants, for overriding base .btn / .modal-content rules. */\n.bg-app-card-i { background: var(--bg-card) !important; }\n.hover-bg-app-hover-i:hover:not(:disabled) { background: var(--bg-hover) !important; }\n\n/* ── Brand gradient utilities ────────────────────────────────────────\n   Same reason as the block above: these tokens hold gradients, so they\n   need the `background` shorthand rather than `bg-[var(--token)]`. */\n\n.bg-gradient-nav-active { background: var(--gradient-nav-active); }\n.bg-gradient-brand-btn { background: var(--gradient-brand-btn); }\n.bg-gradient-brand-accent { background: var(--gradient-brand-accent); }\n.bg-gradient-icon { background: var(--gradient-icon); }\n.bg-icon-chip { background: var(--icon-chip-bg); }\n\n/* Tailwind reads `shadow-[var(--x)]` as a shadow *colour*, not a full\n   box-shadow, so these have to be plain classes. */\n.shadow-nav-active { box-shadow: var(--shadow-nav-active); }\n.shadow-brand-btn { box-shadow: var(--shadow-brand-btn); }\n\n/* Active tab underline. AnalyticsDashboard.css paints `.tab.active::after`\n   with the flat --brand-purple; the extra `.tab` here keeps the gradient\n   winning whichever order the two stylesheets load in. */\n.tab.tab-gradient.active::after { background: var(--gradient-brand-accent); }\n\n/* Donut background track. Recharts puts `className` on the <Pie> group, and a\n   CSS var cannot be handed to the sector through the `fill` prop, so the\n   colour is applied here instead. */\n.donut-track .recharts-sector { fill: var(--donut-track); }\n\n/* Gradient line icons.\n   The icon set in components/Icons.tsx paints with `stroke=\"currentColor\"`,\n   and a gradient is not a <color>, so it cannot be handed down through\n   `color`. Instead we point `stroke` at the <linearGradient> rendered once\n   by <IconGradientDefs />. CSS beats the SVG presentation attribute, and\n   children inherit `stroke` unless they set their own (the `stroke=\"none\"`\n   dots inside IconAgent stay unstroked, as intended). */\n\n.icon-gradient > svg {\n  /* The trailing colour is the SVG paint-server fallback: if <IconGradientDefs />\n     is not mounted on this page the icon still paints flat indigo rather than\n     disappearing. */\n  stroke: url(#vinaIconGradient) #6F6AF8;\n  color: #6F6AF8;\n}\n\n.icon-gradient > svg [fill=\"currentColor\"] { fill: url(#vinaIconGradient) #6F6AF8; }\n\n/* Gradient text (tab labels, emphasised numbers). */\n.text-gradient-brand {\n  background: var(--gradient-brand-accent);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n/* Sticky table headers must be opaque or rows scroll through them. */\n.thead-bg-app-card thead tr,\n.thead-bg-app-card thead th { background: var(--bg-card-flat); }\n\nbody {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI',\n    'Inter', 'Roboto', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: var(--text-base);\n  line-height: 1.6;\n  transition: background var(--transition-base), color var(--transition-base);\n}\n\n.App {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background var(--transition-base), color var(--transition-base);\n}\n\n.project-sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, rgba(129, 140, 248, 0.12), rgba(56, 189, 248, 0.05));\n  border: 1px solid rgba(129, 140, 248, 0.4);\n}\n\n.project-sidebar-header select {\n  text-align: center;\n  text-align-last: center;\n}\n\n.project-sidebar-header select option {\n  background: var(--bg-card);\n  color: var(--text-primary);\n  padding: 8px 12px;\n}\n\n.project-sidebar-header select option:disabled {\n  color: var(--text-muted);\n}\n\n.project-sidebar-header select option[value=\"create-new\"] {\n  font-weight: 600;\n  border-top: 1px solid var(--border-color);\n  margin-top: 4px;\n  padding-top: 12px;\n}\n\n.project-sidebar-logo-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: var(--gradient-brand-deep);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n}\n\n.project-sidebar-project-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--text-muted);\n}\n\n.project-sidebar-project-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  padding-right: 4px;\n  margin-right: 2px;\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n/* Scrollable panels (e.g. conversation list) — same scrollbar chrome as .sidebar-nav */\n.scrollbar-themed {\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n  padding-right: 4px;\n  margin-right: 2px;\n  box-sizing: border-box;\n}\n\n.sidebar-nav::-webkit-scrollbar,\n.scrollbar-themed::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track,\n.scrollbar-themed::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n  border-radius: var(--radius-full);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb,\n.scrollbar-themed::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb);\n  border-radius: var(--radius-full);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover,\n.scrollbar-themed::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollbar-thumb-hover);\n}\n\n.sidebar-project-switcher {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.sidebar-project-switcher select {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-input);\n  color: var(--text-secondary);\n  font-size: 13px;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.sidebar-project-switcher select:focus {\n  border-color: rgba(165, 180, 252, 0.9);\n  box-shadow:\n    0 0 0 1px rgba(129, 140, 248, 0.9),\n    0 0 0 6px rgba(79, 70, 229, 0.25);\n}\n\n\n/* ── Mobile: sidebar becomes a slide-in drawer ────────────────── */\n\n.container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: var(--space-8) var(--space-6) var(--space-10);\n}\n\n/* Conversation History — stay within viewport on narrow screens */\n.conversations-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.container.conversations-page {\n  max-width: min(1280px, 100%);\n}\n\n@media (max-width: 640px) {\n  .conversations-page.container {\n    padding-left: var(--space-4);\n    padding-right: var(--space-4);\n  }\n}\n\n.conversations-page .breadcrumbs {\n  flex-wrap: wrap;\n  row-gap: 6px;\n  min-width: 0;\n}\n\n.conversations-page .header {\n  flex-wrap: wrap;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.conversations-page .header h1 {\n  min-width: 0;\n  flex: 1 1 12rem;\n  font-size: clamp(1.125rem, 4.2vw, var(--text-3xl));\n}\n\n.conversations-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--space-4);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 900px) {\n  .conversations-layout {\n    grid-template-columns: minmax(260px, min(38vw, 400px)) minmax(0, 1fr);\n    gap: var(--space-6);\n    align-items: start;\n  }\n}\n\n.conversations-layout > .card {\n  min-width: 0;\n  max-width: 100%;\n}\n\n/* Conversation list panel — readable text on dark cards + responsive scroll */\n.conversations-page .conversation-list-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-2) var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n.conversations-page .conversation-list-title {\n  font-size: var(--text-xl);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n:root[data-theme='light'] .conversations-page .conversation-list-count,\n:root[data-theme='light'] .conversations-page .conversation-list-msg-count {\n  color: var(--text-accent);\n}\n\n.conversations-page .conversation-list-count {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  color: var(--text-accent-light);\n  white-space: nowrap;\n}\n\n.conversations-page .conversation-list-filter.form-group {\n  margin-bottom: var(--space-4);\n}\n\n.conversations-page .conversation-list-scroll {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  max-height: min(600px, calc(100vh - 260px));\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n}\n\n.conversations-page .conversation-list-scroll .conversation-list-item {\n  margin-bottom: 0;\n}\n\n.conversations-page .conversation-list-item {\n  padding: var(--space-4);\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: var(--radius-xl);\n  text-align: left;\n}\n\n.conversations-page .conversation-list-item:focus-visible {\n  outline: 2px solid var(--border-hover);\n  outline-offset: 2px;\n}\n\n.conversations-page .conversation-list-item--ended {\n  opacity: 0.88;\n}\n\n.conversations-page .conversation-list-row-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--space-3);\n  margin-bottom: var(--space-2);\n}\n\n.conversations-page .conversation-list-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  align-items: center;\n  min-width: 0;\n}\n\n.conversations-page .conversation-list-date {\n  font-size: var(--text-xs);\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.conversations-page .conversation-list-msg-count {\n  font-size: var(--text-xs);\n  font-weight: 600;\n  color: var(--text-accent-light);\n  margin: 0 0 var(--space-2);\n  letter-spacing: 0.02em;\n}\n\n.conversations-page .conversation-list-preview {\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n  line-height: 1.45;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n@media (max-width: 480px) {\n  .conversations-page .conversation-list-scroll {\n    max-height: min(48vh, 380px);\n  }\n}\n\n.conversations-page .message-bubble,\n.conversations-page .chat-message-content {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.conversations-page .message {\n  max-width: 100%;\n}\n\n.conversations-page .info-box {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.header {\n  background: var(--bg-header);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6) var(--space-8);\n  margin-bottom: var(--space-6);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  transition: background var(--transition-base), border-color var(--transition-base);\n}\n\n.header h1 {\n  font-size: var(--text-3xl);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n\n.header-subtitle {\n  margin-top: var(--space-1);\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: var(--space-3);\n  flex-shrink: 0;\n}\n\n.btn {\n  padding: var(--space-2) var(--space-5);\n  border: none;\n  border-radius: var(--radius-lg);\n  font-size: var(--text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  white-space: nowrap;\n  line-height: 1.5;\n  min-height: 38px;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.btn-primary {\n  background: var(--gradient-brand-btn);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(59, 91, 245, 0.4), 0 0 0 1px rgba(59, 91, 245, 0.3);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 91, 245, 0.5), 0 0 0 1px rgba(34, 199, 232, 0.5);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-secondary {\n  background: var(--bg-input);\n  color: var(--text-secondary);\n  box-shadow: 0 0 0 1px var(--border-color);\n  transition: all var(--transition-fast);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--bg-hover);\n  box-shadow: 0 0 0 1px var(--border-hover);\n  color: var(--text-primary);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #EF4444, #DC2626);\n  color: #FEE2E2;\n  box-shadow: 0 1px 3px rgba(239, 68, 68, 0.3), 0 0 0 1px rgba(248, 113, 113, 0.4);\n}\n\n.btn-danger:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4), 0 0 0 1px rgba(248, 113, 113, 0.6);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text-muted);\n  box-shadow: none;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: var(--bg-subtle);\n  color: var(--text-secondary);\n}\n\n.btn-sm {\n  padding: var(--space-1) var(--space-3);\n  font-size: var(--text-xs);\n  min-height: 30px;\n  border-radius: var(--radius-md);\n}\n\n.btn-lg {\n  padding: var(--space-3) var(--space-8);\n  font-size: var(--text-md);\n  min-height: 44px;\n}\n\n.btn-block {\n  width: 100%;\n}\n\n.card {\n  background: var(--bg-card);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-6);\n  margin-bottom: var(--space-5);\n  box-shadow: var(--shadow-card);\n  border: 1px solid var(--border-color);\n  transition: all var(--transition-base);\n}\n\n.card h2,\n.card h3 {\n  color: var(--text-primary);\n}\n\n.card-title {\n  font-size: var(--text-2xl);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: var(--space-2);\n  letter-spacing: -0.01em;\n}\n\n.automation-form-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-4);\n}\n\n.automation-form-grid-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: var(--space-4);\n}\n\n@media (max-width: 640px) {\n  .automation-form-grid-2,\n  .automation-form-grid-3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.card-subtitle {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin-bottom: var(--space-6);\n}\n\n.card-interactive {\n  cursor: pointer;\n}\n\n.card-interactive:hover {\n  border-color: var(--border-hover);\n  box-shadow: var(--shadow-card-hover);\n  transform: translateY(-2px);\n}\n\n.card-interactive:active {\n  transform: translateY(0);\n}\n\n.card-highlighted {\n  border: 1.5px solid var(--border-accent);\n  background: var(--bg-subtle);\n}\n\n.card-success {\n  border: 1.5px solid rgba(34, 197, 94, 0.3);\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.04) 0%, rgba(139, 92, 246, 0.04) 100%);\n}\n\n.form-group {\n  margin-bottom: var(--space-5);\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: var(--space-2);\n  font-weight: 500;\n  font-size: var(--text-sm);\n  color: var(--text-tertiary);\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-base);\n  font-family: inherit;\n  background: var(--bg-input);\n  color: var(--text-secondary);\n  outline: none;\n  transition: all var(--transition-fast);\n  line-height: 1.5;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  border-color: var(--border-hover);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15);\n}\n\n.form-group textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.form-group input:disabled,\n.form-group textarea:disabled,\n.form-group select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.form-label-uppercase {\n  font-size: var(--text-xs);\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: var(--space-2);\n  display: block;\n}\n\n.form-hint {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n  margin-top: var(--space-1);\n  line-height: 1.5;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.status-active {\n  background: rgba(34, 197, 94, 0.18);\n  color: #6ee7b7;\n  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.45);\n}\n\n.status-inactive {\n  background-color: rgba(239, 68, 68, 0.18);\n  color: #fecaca;\n  box-shadow: 0 0 0 1px rgba(248, 113, 113, 0.6);\n}\n\n.status-processing {\n  background-color: rgba(59, 130, 246, 0.18);\n  color: #bfdbfe;\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);\n}\n\n.status-ready {\n  background-color: rgba(34, 197, 94, 0.18);\n  color: #bbf7d0;\n  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.55);\n}\n\n.status-connected {\n  background-color: rgba(34, 197, 94, 0.18);\n  color: #bbf7d0;\n  box-shadow: 0 0 0 1px rgba(74, 222, 128, 0.6);\n}\n\n.status-disconnected {\n  background-color: rgba(248, 113, 113, 0.22);\n  color: #fecaca;\n  box-shadow: 0 0 0 1px rgba(248, 113, 113, 0.7);\n}\n\n.status-draft {\n  background-color: rgba(107, 114, 128, 0.18);\n  color: #d1d5db;\n  box-shadow: 0 0 0 1px rgba(107, 114, 128, 0.5);\n}\n\n.status-training {\n  background-color: rgba(59, 130, 246, 0.18);\n  color: #bfdbfe;\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.5);\n}\n\n.status-live {\n  background-color: rgba(34, 197, 94, 0.18);\n  color: #6ee7b7;\n  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.45);\n}\n\n.status-paused {\n  background-color: rgba(245, 158, 11, 0.18);\n  color: #fde68a;\n  box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.5);\n}\n\n:root[data-theme='light'] .status-active,\n:root[data-theme='light'] .status-live,\n:root[data-theme='light'] .status-ready,\n:root[data-theme='light'] .status-connected {\n  color: #15803d;\n}\n\n:root[data-theme='light'] .status-inactive,\n:root[data-theme='light'] .status-disconnected {\n  color: #b91c1c;\n}\n\n:root[data-theme='light'] .status-processing,\n:root[data-theme='light'] .status-training {\n  color: #1d4ed8;\n}\n\n:root[data-theme='light'] .status-draft {\n  color: #374151;\n}\n\n:root[data-theme='light'] .status-paused {\n  color: #92400e;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  transition: background-color 0.3s ease;\n}\n\n:root[data-theme='light'] .modal-overlay {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-content {\n  background: var(--bg-card);\n  border-radius: 18px;\n  padding: 24px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-color);\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: color 0.2s ease;\n}\n\n.close-btn:hover {\n  color: var(--text-secondary);\n}\n\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid-2 {\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n.grid-3 {\n  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n}\n\n.tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: var(--space-6);\n  gap: var(--space-1);\n}\n\n.tab {\n  padding: var(--space-3) var(--space-5);\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  font-size: var(--text-sm);\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: -1px;\n  transition: all var(--transition-fast);\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n\n.tab.active {\n  color: var(--text-accent);\n  border-bottom-color: var(--brand-purple);\n}\n\n.tab:hover:not(.active):not(:disabled) {\n  color: var(--text-secondary);\n  background: var(--bg-subtle);\n}\n\n.tab:disabled,\n.tab.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: rgba(31, 41, 55, 0.95);\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--brand-purple-deep);\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--brand-purple-deep);\n  cursor: pointer;\n  border: none;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #4b5563;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked+.toggle-slider {\n  background-color: var(--brand-purple-deep);\n}\n\ninput:checked+.toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.code-block {\n  background: var(--bg-input);\n  color: var(--text-secondary);\n  padding: 16px;\n  border-radius: 6px;\n  font-family: 'Courier New', monospace;\n  font-size: 12px;\n  overflow-x: auto;\n  margin: 16px 0;\n  border: 1px solid var(--border-color);\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n  background: var(--bg-card);\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: transparent;\n}\n\n.message {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.message.user {\n  align-items: flex-end;\n}\n\n.message.agent {\n  align-items: flex-start;\n}\n\n.message-bubble {\n  max-width: 70%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  word-wrap: break-word;\n}\n\n.message.user .message-bubble {\n  background: var(--gradient-brand-deep);\n  color: #f9fafb;\n  border-bottom-right-radius: 4px;\n}\n\n.message.agent .message-bubble {\n  background-color: var(--bg-input);\n  color: var(--text-secondary);\n  border-bottom-left-radius: 4px;\n  box-shadow: var(--shadow-sm);\n}\n\n.message-sender {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.chat-input-container {\n  padding: 16px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-input);\n  display: flex;\n  gap: 12px;\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  font-size: 14px;\n  background: var(--bg-card);\n  color: var(--text-secondary);\n  transition: all 0.2s ease;\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: rgba(129, 140, 248, 1);\n  box-shadow:\n    0 0 0 1px rgba(129, 140, 248, 1),\n    0 0 0 8px rgba(79, 70, 229, 0.28);\n}\n\n/* Auth Layout Styles */\n.auth-layout {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-primary);\n  padding: 20px;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 440px;\n  background: var(--bg-card);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-color);\n}\n\n.auth-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n.auth-subtitle {\n  font-size: 15px;\n  color: var(--text-muted);\n  text-align: center;\n  margin-bottom: 32px;\n  line-height: 1.5;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.auth-footer {\n  margin-top: 24px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.auth-link {\n  color: var(--brand-purple);\n  text-decoration: none;\n  font-weight: 600;\n  transition: color var(--transition-fast);\n}\n\n.auth-link:hover {\n  color: var(--brand-purple-deep);\n  text-decoration: underline;\n}\n\n/* ============================================\n   APP COMPONENT PATTERNS\n   ============================================ */\n\n/* ── Info/Tip Boxes ─────────────────────── */\n.info-box {\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-sm);\n  line-height: 1.6;\n}\n\n.info-box-purple {\n  background: rgba(79, 70, 229, 0.08);\n  border: 1px solid rgba(79, 70, 229, 0.2);\n  color: var(--brand-purple);\n}\n\n.info-box-blue {\n  background: rgba(59, 130, 246, 0.08);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  color: var(--color-info);\n}\n\n.info-box-success {\n  background: rgba(34, 197, 94, 0.08);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: var(--color-success);\n}\n\n.info-box-error {\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: var(--color-error);\n}\n\n/* ── Empty State ────────────────────────── */\n.empty-state {\n  text-align: center;\n  padding: var(--space-16) var(--space-8);\n}\n\n.empty-state-icon {\n  font-size: 3rem;\n  margin-bottom: var(--space-5);\n  opacity: 0.6;\n}\n\n.empty-state-title {\n  font-size: var(--text-3xl);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: var(--space-3);\n  letter-spacing: -0.02em;\n}\n\n.empty-state-desc {\n  font-size: var(--text-md);\n  color: var(--text-muted);\n  max-width: 480px;\n  margin: 0 auto var(--space-8);\n  line-height: 1.7;\n}\n\n\n/* ── Avatar ─────────────────────────────── */\n.avatar {\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  background: var(--bg-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-sm {\n  width: 32px;\n  height: 32px;\n  font-size: var(--text-sm);\n}\n\n.avatar-md {\n  width: 48px;\n  height: 48px;\n  font-size: var(--text-xl);\n}\n\n.avatar-lg {\n  width: 64px;\n  height: 64px;\n  font-size: var(--text-3xl);\n}\n\n.avatar-xl {\n  width: 96px;\n  height: 96px;\n  font-size: 2.5rem;\n}\n\n.avatar-initial {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* ── Detail Grid ────────────────────────── */\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-4);\n}\n\n@media (max-width: 768px) {\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.detail-value {\n  font-size: var(--text-md);\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n/* ── Display Field (read-only styled box) ── */\n\n.display-field {\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-lg);\n  background: var(--bg-input);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  font-size: var(--text-md);\n  line-height: 1.6;\n}\n\n.display-field-lg {\n  min-height: 80px;\n  white-space: pre-wrap;\n}\n\n/* ── Value Badge (small colored pill) ────── */\n\n.value-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-size: var(--text-sm);\n  font-weight: 500;\n  background: rgba(79, 70, 229, 0.15);\n  color: var(--brand-purple);\n  border: 1px solid rgba(79, 70, 229, 0.2);\n}\n\n/* ── Status Pill Selector ───────────────── */\n.status-selector {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n\n.status-option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: var(--space-2) var(--space-4);\n  min-width: 100px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  background: var(--bg-input);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-family: inherit;\n}\n\n.status-option:hover:not(:disabled) {\n  border-color: var(--border-hover);\n}\n\n.status-option.active {\n  background: var(--gradient-brand-deep);\n  color: #f1f5f9;\n  border-color: transparent;\n  box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3);\n}\n\n.status-option:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.status-option-label {\n  font-weight: 600;\n  font-size: var(--text-sm);\n}\n\n.status-option-desc {\n  font-size: var(--text-xs);\n  opacity: 0.8;\n  margin-top: 2px;\n}\n\n/* ── Code Embed Tabs ────────────────────── */\n.embed-tabs {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n  margin-bottom: var(--space-3);\n}\n\n.embed-tab {\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  background: var(--bg-input);\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: var(--text-xs);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-family: inherit;\n}\n\n.embed-tab:hover {\n  border-color: var(--border-hover);\n}\n\n.embed-tab.active {\n  border-color: var(--brand-purple);\n  background: rgba(79, 70, 229, 0.12);\n  color: var(--brand-purple);\n}\n\n/* ── WhatsApp Account Card ──────────────── */\n.whatsapp-account-card {\n  padding: var(--space-4);\n  border: 1px solid var(--border-accent);\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--space-3);\n  background: var(--bg-subtle);\n  transition: all var(--transition-fast);\n}\n\n.whatsapp-account-card:hover {\n  border-color: var(--border-hover);\n}\n\n/* ── Dashed Add Card ────────────────────── */\n.add-card-dashed {\n  padding: var(--space-4);\n  border: 2px dashed var(--border-accent);\n  border-radius: var(--radius-lg);\n  margin-top: var(--space-6);\n  transition: all var(--transition-fast);\n}\n\n.add-card-dashed:hover {\n  border-color: var(--border-hover);\n}\n\n/* ── Stats Row ──────────────────────────── */\n.stats-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: var(--space-5);\n  background: var(--bg-surface);\n  border-radius: var(--radius-2xl);\n  border: 1px solid var(--border-subtle);\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-value {\n  font-size: var(--text-4xl);\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.stat-label {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  margin-top: var(--space-1);\n}\n\n/* ── Step Instructions ──────────────────── */\n.steps-list {\n  padding-left: var(--space-5);\n  color: var(--text-accent-light);\n  line-height: 2;\n  font-size: var(--text-sm);\n}\n\n.steps-list li {\n  margin-bottom: var(--space-2);\n}\n\n/* ── Workspace Card ─────────────────────── */\n.workspace-card {\n  cursor: pointer;\n  padding: var(--space-6);\n  border-radius: var(--radius-2xl);\n  box-shadow: var(--shadow-card);\n  border: 1px solid var(--border-color);\n  background: var(--bg-card);\n  transition: all var(--transition-fast);\n}\n\n.workspace-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-card-hover);\n  border-color: var(--border-hover);\n}\n\n.workspace-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--space-4);\n}\n\n.workspace-card-name {\n  font-size: var(--text-xl);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.workspace-card-footer {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-subtle);\n}\n\n/* ── Grid Layouts ───────────────────────── */\n.grid-auto {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n/* ============================================\n   CHANNELS PAGE\n   ============================================ */\n\n/* Live Banner */\n/* ── Channels Page: Overview Mode ──────────────── */\n.channels-row-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.channel-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4) var(--space-5);\n  border-radius: var(--radius-xl);\n  border: 1.5px solid var(--border-color);\n  background: var(--bg-card);\n  transition: border-color 0.2s ease;\n}\n\n.channel-row:hover {\n  border-color: var(--border-hover);\n}\n\n.channel-row-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.channel-row-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.channel-row-icon.web {\n  background: rgba(79, 70, 229, 0.12);\n  color: #818cf8;\n}\n\n.channel-row-icon.whatsapp {\n  background: rgba(59, 130, 246, 0.12);\n  color: #60a5fa;\n}\n\n.channel-row-icon.voice {\n  background: rgba(129, 140, 248, 0.12);\n  color: #818cf8;\n}\n\n.channel-row-name {\n  font-size: var(--text-md);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.channel-row-right {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.channel-row-status {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  color: var(--text-muted);\n  min-width: 52px;\n}\n\n.channel-row-status.active {\n  color: var(--text-primary);\n}\n\n.btn-configure:active {\n  transform: translateY(0);\n}\n\n/* ── Channels Page: Configure Top Bar ──────────── */\n.channel-config-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4) var(--space-5);\n  border-radius: var(--radius-xl);\n  border: 1.5px solid var(--border-color);\n  background: var(--bg-card);\n  margin-bottom: var(--space-5);\n}\n\n.channel-config-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.channel-config-topbar-name {\n  font-size: var(--text-lg);\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.channel-config-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .channel-row {\n    flex-direction: column;\n    gap: var(--space-3);\n    align-items: flex-start;\n  }\n\n  .channel-row-right {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .channel-config-topbar {\n    flex-direction: column;\n    gap: var(--space-3);\n    align-items: flex-start;\n  }\n\n  .channel-config-topbar-right {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n/* ============================================\n   SIDEBAR USER MENU\n   ============================================ */\n/* ── Support Ticket Chat History Markdown Styles ───────────────── */\n.chat-message-content {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.chat-message-content p {\n  margin: 0 0 8px 0;\n}\n\n.chat-message-content p:last-child {\n  margin-bottom: 0;\n}\n\n.chat-message-content h1,\n.chat-message-content h2,\n.chat-message-content h3,\n.chat-message-content h4,\n.chat-message-content h5,\n.chat-message-content h6 {\n  margin: 12px 0 8px 0;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--text-primary);\n}\n\n.chat-message-content h1:first-child,\n.chat-message-content h2:first-child,\n.chat-message-content h3:first-child,\n.chat-message-content h4:first-child,\n.chat-message-content h5:first-child,\n.chat-message-content h6:first-child {\n  margin-top: 0;\n}\n\n.chat-message-content h1 {\n  font-size: 1.5em;\n}\n\n.chat-message-content h2 {\n  font-size: 1.3em;\n}\n\n.chat-message-content h3 {\n  font-size: 1.1em;\n}\n\n.chat-message-content ul,\n.chat-message-content ol {\n  margin: 8px 0;\n  padding-left: 24px;\n}\n\n.chat-message-content li {\n  margin: 4px 0;\n  line-height: 1.5;\n}\n\n.chat-message-content code {\n  background: rgba(0, 0, 0, 0.1);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 0.9em;\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .chat-message-content code {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.chat-message-content pre {\n  background: rgba(0, 0, 0, 0.05);\n  padding: 12px;\n  border-radius: 6px;\n  overflow-x: auto;\n  margin: 8px 0;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 0.9em;\n  line-height: 1.4;\n}\n\n:root[data-theme='dark'] .chat-message-content pre {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.chat-message-content pre code {\n  background: none;\n  padding: 0;\n}\n\n.chat-message-content blockquote {\n  border-left: 3px solid rgba(0, 0, 0, 0.2);\n  padding-left: 12px;\n  margin: 8px 0;\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n:root[data-theme='dark'] .chat-message-content blockquote {\n  border-left-color: rgba(255, 255, 255, 0.3);\n}\n\n.chat-message-content a {\n  color: var(--brand-blue);\n  text-decoration: underline;\n  word-break: break-all;\n}\n\n.chat-message-content a:hover {\n  opacity: 0.8;\n}\n\n.chat-message-content strong {\n  font-weight: 600;\n}\n\n.chat-message-content em {\n  font-style: italic;\n}\n\n.chat-message-content hr {\n  border: none;\n  border-top: 1px solid var(--border-primary);\n  margin: 12px 0;\n}\n\n/* ============================================\n   LOADER COMPONENT\n   ============================================ */\n\n.loader-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 200px;\n  /* Ensure visibility */\n}\n\n.loader {\n  display: flex;\n  gap: 10px;\n}\n\n.loader span {\n  height: 20px;\n  width: 20px;\n  background-image: var(--gradient-brand-deep);\n  border-radius: 50%;\n  animation-name: animar;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  box-shadow: var(--shadow-lg);\n}\n\n#one {\n  animation-delay: 1s;\n}\n\n#two {\n  animation-delay: 2s;\n}\n\n#three {\n  animation-delay: 3s;\n}\n\n@keyframes animar {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  33% {\n    transform: scale(.3);\n    opacity: 0.7;\n  }\n\n  66% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
